import {h} from 'preact';

function Button(props) {
    return (
        <div className="oQuiz__Action">
            {<button className="aActionButton" disabled={!props.valid}>
                <span className="aActionButton__Inner">Répondre</span>
            </button>}
        </div>
    )
}

export default Button
